
import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "lib/utils/common_utils";
import { DialogContent, IconButton, Typography } from "@material-ui/core";
import FileUpload from "components/form_components/fileUpload";

const useStyles = makeStyles((theme) => ({
    certDialog: {
        "& .MuiDialog-paper": {
            boxShadow: "0px 3px 6px #00000029",
            position: "absolute",
            left: "calc(50% - 250px)",
            width: '44%'
        },
    },
}));
function TechFilesPopup(props) {
    const { handleClose, currentSelectedRow, open } = props
    const classes = useStyles();
    return (
        <div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="755px"
                style={{
                    minHeight: "256",
                    // left: "20%",
                    boxShadow: "0px 3px 6px #00000029",
                }}
                className={classes.certDialog}
            >
                <div style={{ padding: "20px", overflow: "hidden" }}>
                    <Typography
                        color="primary"
                        varient="h3"
                        style={{ marginBottom: "10px" }}
                    >
                        Files
                    </Typography>
                    <div>
                        <FileUpload
                            defaultValue={currentSelectedRow.maintenance_file !== undefined
                                ? currentSelectedRow.maintenance_file.map((file) => ({
                                    filename: file?.file_name,
                                    url: file?.file_path,
                                    id: file?.id,
                                })) : " "
                            }
                            APIUrl={""}

                            // setFiles={setPrePackingFiles}
                            showBorderOnNoFiles={true}
                            uploadButtonView={true}
                            multiple={true}
                            name={"maintenance_file"}
                            action={"Upload Document"}


                        />
                    </div>
                </div>

            </Dialog>
        </div>
    )
}

export default TechFilesPopup